import { render, staticRenderFns } from "./Product2.vue?vue&type=template&id=0db6b302&scoped=true"
import script from "./Product2.vue?vue&type=script&lang=js"
export * from "./Product2.vue?vue&type=script&lang=js"
import style0 from "./Product2.vue?vue&type=style&index=0&id=0db6b302&prod&lang=scss"
import style1 from "./Product2.vue?vue&type=style&index=1&id=0db6b302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db6b302",
  null
  
)

export default component.exports